module.exports = {"410726100":"城关镇","410726101":"东屯镇","410726102":"丰庄镇","410726103":"石婆固镇","410726104":"王楼镇","410726200":"僧固乡","410726202":"位邱乡","410726203":"司寨乡","410726205":"马庄乡","410726206":"胙城乡","410726207":"榆林乡","410726208":"小潭乡","410726400":"国营林场","410726401":"新兴农场","410726402":"新乡市食品工业聚集区","410726403":"新乡市纺织工业聚集区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410726.json
// module id = 1457
// module chunks = 0